export type { IAutoCompleteGroup, IAutoCompleteOptions } from './autocomplete';

export { default } from './autocomplete';
